var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSobreNaoSelecionado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 30.5C26.0228 30.5 30.5 26.0228 30.5 20.5C30.5 14.9772 26.0228 10.5 20.5 10.5C14.9772 10.5 10.5 14.9772 10.5 20.5C10.5 26.0228 14.9772 30.5 20.5 30.5Z",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.5V20.5M20.5 16.5H20.51",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSobreNaoSelecionado);
export default __webpack_public_path__ + "static/media/iconSobreNaoSelecionado.02b8cc53e91694fa3942a14ad43332ce.svg";
export { ForwardRef as ReactComponent };